import _ from 'lodash';
import { BrandApi } from '../../../swagger_client/src';
import { useTranslation } from 'react-i18next';
import useGet from '../../Hooks/useGet';
import { createInputValueRegexContent } from '../../../Utils/filter/createFilterInputValue';

export default function useBrandsFilter() {
  const brandApi = new BrandApi(),
    { data } = useGet<{ count: number } | undefined>((f: Object) =>
      brandApi.brandCount(f)
    ),
    { t } = useTranslation();

  async function promiseOptions(inputValue?: string) {
    const filter: { limit: number; order: string; where?: Object } = {
      limit: 50,
      order: 'name asc',
    };

    if (inputValue) {
      filter.where = { name: { regexp: `/${createInputValueRegexContent(inputValue)}/i` } };
    }

    const items = await brandApi.brandFind({
      filter: JSON.stringify(filter),
    });

    const options = _.map(items, (o) => {
      return {
        label: o.label || o.name,
        value: o.id,
      };
    });
    return options
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  return {
    fetcher: promiseOptions,
    options: {
      placeholder: t('Select brand'),
      isMulti: true,
    },
    count: data?.count
  };
}
